<template>
  <v-container>
    <v-col>
      <v-row no-gutters class="d-flex bg-surface-variant">
        <p class="mr-3 mt-1 text-style">ECA fuel</p>

        <v-col class="mr-3">
          <ThemedTextField
            label="Cost ($)"
            v-model="ecaFuelPriceModel"
            outlined
            persistent-placeholder
          >
          </ThemedTextField>
        </v-col>
        <v-col>
          <ThemedTextField
            label="LHV (MJ/kg)"
            v-model="ecaFuelEnergyModel"
            outlined
            persistent-placeholder
          >
          </ThemedTextField>
        </v-col>
      </v-row>
      <v-row no-gutters class="d-flex bg-surface-variant">
        <p class="mr-3 mt-1 text-style">non-ECA fuel</p>
        <v-col class="mr-3">
          <ThemedTextField
            label="Cost ($)"
            v-model="nonEcaFuelPriceModel"
            outlined
            persistent-placeholder
          >
          </ThemedTextField>
        </v-col>
        <v-col>
          <ThemedTextField
            label="LHV (MJ/kg)"
            v-model="nonEcaFuelEnergyModel"
            outlined
            persistent-placeholder
          >
          </ThemedTextField>
        </v-col>
      </v-row>
      <v-row no-gutters class="d-flex bg-surface-variant">
        <p class="mr-3 mt-1 text-style">Daily Costs</p>
        <v-col class="mr-3" :cols="4">
          <ThemedTextField
            label="Cost ($)"
            v-model="dailyCostsModel"
            outlined
            persistent-placeholder
          >
          </ThemedTextField>
        </v-col>
      </v-row>
    </v-col>
  </v-container>
</template>
      
      
      <script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "CostSettings",
  components: {
    ThemedTextField,
  },
  computed: {
    ...mapState("weatherRouting/formModule", [
      "ecaFuelPrice",
      "nonEcaFuelPrice",
      "dailyCosts",
      "ecaFuelEnergy",
      "nonEcaFuelEnergy",
    ]),
    ecaFuelPriceModel: {
      get() {
        return this.ecaFuelPrice;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_ECA_FUEL_PRICE",
          value,
          { root: true }
        );
      },
    },
    nonEcaFuelPriceModel: {
      get() {
        return this.nonEcaFuelPrice;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_NON_ECA_FUEL_PRICE",
          value,
          { root: true }
        );
      },
    },
    dailyCostsModel: {
      get() {
        return this.dailyCosts;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_DAILY_COSTS", value, {
          root: true,
        });
      },
    },
    ecaFuelEnergyModel: {
      get() {
        return this.ecaFuelEnergy;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_ECA_FUEL_ENERGY",
          value,
          {
            root: true,
          }
        );
      },
    },
    nonEcaFuelEnergyModel: {
      get() {
        return this.nonEcaFuelEnergy;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_NON_ECA_FUEL_ENERGY",
          value,
          {
            root: true,
          }
        );
      },
    },
  },
};
</script>
    
    <style scoped>
.text-style {
  color: var(--color-text);
}
</style>